<script lang="ts">
    import { Container, Row } from "sveltestrap";
    import Blockquotes from "./Blockquotes.svelte";
    import BookmarkTypography from "./BookmarkTypography.svelte";
    import DisplayHeadings from "./DisplayHeadings.svelte";
    import FontThin from "./FontThin.svelte";
    import Headings from "./Headings.svelte";
    import HeadingsFancy from "./HeadingsFancy.svelte";
    import InlineElement from "./InlineElement.svelte";
    import LeadParagraph from "./LeadParagraph.svelte";
    import ListingTypography from "./ListingTypography/ListingTypography.svelte";
    import TextColor from "./TextColor.svelte";
    import { onMount } from "svelte";
    import PreLodaer from "../../../Layout/PreLoader/PreLodaer.svelte";
    let ispreloader: boolean = false;
    onMount(() => {
        setTimeout(() => {
            ispreloader = true;
        }, 1000);
    });
</script>

{#if !ispreloader}
    <PreLodaer />
{/if}
<BookmarkTypography />
<Container fluid>
    <Row>
        <Headings />
        <FontThin />
        <HeadingsFancy />
        <DisplayHeadings />
        <LeadParagraph />
        <InlineElement />
        <TextColor />
        <ListingTypography />
        <Blockquotes />
    </Row>
</Container>
